<template>
  <router-view />
</template>
<script>
export default {
  name: 'SubHome',
};
</script>

<style scoped></style>
